module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "cart"
  }, [_c('h1', [_vm._v("Books")]), _vm._v(" "), _c('ul', _vm._l((_vm.items), function(item) {
    return _c('li', [_vm._v("\n            " + _vm._s(item.name) + " (Quantity: " + _vm._s(item.quantity) + ")\n            "), _c('p', [_vm._v("TAG: " + _vm._s(item.tag))])])
  })), _vm._v(" "), _c('p', [_vm._v("Total: " + _vm._s(_vm.total))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-86c639fc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/books/Cart.vue
// module id = 289
// module chunks = 1